import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useTheme } from '@/components/providers/theme-provider';
import { BrandLogo } from '@/components/ui/BrandLogo';
import { Moon, Sun, Search } from 'lucide-react';

const PublicHeader: React.FC = () => {
  const { theme, setTheme } = useTheme();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/marketplace?search=${encodeURIComponent(searchQuery.trim())}`);
    } else {
      navigate('/marketplace');
    }
  };

  return (
    <header id="public-header" className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-sm">
      <div id="public-header-container" className="container mx-auto flex h-16 items-center justify-between px-4 md:px-6">
        <BrandLogo size="lg" showText={true} linkTo="/" />
        <nav id="public-header-nav" className="hidden items-center gap-6 md:flex">
          <Link
            to="/marketplace"
            className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
          >
            Marketplace
          </Link>
        </nav>
        
        {/* Search Bar */}
        <div id="public-header-search" className="flex-1 flex items-center justify-center px-4 max-w-md hidden sm:flex">
          <form onSubmit={handleSearch} className="relative w-full">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="h-4 w-4 text-muted-foreground" />
            </div>
            <Input
              id="public-header-search-input"
              className="pl-10 w-full"
              placeholder="Search agents..."
              type="search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </form>
        </div>
        <div id="public-header-actions" className="flex items-center gap-4">
          {/* Mobile Search Button */}
          <Button 
            id="public-header-mobile-search"
            variant="ghost" 
            size="sm" 
            onClick={() => navigate('/marketplace')}
            className="sm:hidden"
          >
            <Search className="h-4 w-4" />
            <span className="sr-only">Search agents</span>
          </Button>
          
          <Button 
            id="public-header-theme-toggle"
            variant="ghost" 
            size="sm" 
            onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          >
            {theme === 'dark' ? (
              <Sun className="h-4 w-4" />
            ) : (
              <Moon className="h-4 w-4" />
            )}
            <span className="sr-only">Toggle theme</span>
          </Button>
          <Button id="public-header-login-btn" asChild variant="outline">
            <Link to="/login">Login</Link>
          </Button>
          <Button id="public-header-signup-btn" asChild>
            <Link to="/register">Sign Up</Link>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
